var exports = {
  "kL": "x61f99309--f3c1ba--container",
  "my": "x61f99309--f3c1ba--avatar",
  "Qs": "x61f99309--f3c1ba--content",
  "Qq": "x61f99309--f3c1ba--text",
  "h0": "x61f99309--f3c1ba--short",
  "qV": "x61f99309--f3c1ba--skeleton",
  "iM": "x61f99309--f3c1ba--shimmer",
};

module.exports = exports;
